import React from 'react';



export interface IProps {}

export const FC: React.FC<IProps> = () => {
  const markerIo = process.env['REACT_APP_MARKER_IO_API_KEY'];

  React.useEffect(() => {
    if (markerIo && markerIo !== 'null') {
      (window as any).markerConfig = {
        destination: markerIo
      };

      ((win: any, doc: any) => {
        if (win.__Marker) {
          return;
        }

        const elScript = doc.createElement('script');
        elScript.async = 1;
        elScript.src = 'https://edge.marker.io/latest/shim.js';
        const els = doc.getElementsByTagName('script')[0];
        els.parentNode.insertBefore(elScript, els);
      })(window, document);
    }
  }, [markerIo]);

  return null;
};
